import { useEffect } from 'react'

import { registerForceLogoutHandler } from './force-logout'
import { useLogout } from './use-logout'

/**
 * Registers the forced sign-out handler used by the HTTP layers.
 *
 * Reuses `useLogout` so a forced sign-out tears down exactly what the manual
 * one does: session claims and the current user. Must be mounted inside both
 * SessionProvider and UserProvider.
 */
export function ForceLogoutBridge() {
  const logout = useLogout()

  useEffect(() => registerForceLogoutHandler(logout), [logout])

  return null
}
